import { DropTarget } from 'react-dnd'
import React, { Component } from 'react';

const Types = {
	ITEM: 'product'
}

const itemTarget = {
	hover(props) {
		props.calculatePreviewCells(props.details.id);
	},

	drop(props) {
		// Add product to the array of rendered items
		// Parameters: Currently Dragging Product, ID of the cell we dropped the product to, type of the product
		// props.addRenderedProductToState(props.appState.draggingProduct, props.details.id, props.appState.willOccupyCells);

		props.dropToTheRightCell(props.appState.draggingProduct, props.details.id, props.appState.willOccupyCells);

		// Make the dropped item unavailable
		// First argument is cell ID, second argument is how much cells will be occupied
		// Calcullate accordingly
		// props.updateCellAvailability(1, 1)
	},

	canDrop(props, monitor) {
		// Check when to return
		const {willOccupyCells, cells, hoverCell, activeInitialBaseplate, cells_10x3, cells_10x2_KOMPANJA, cells_8x1, cells_8x2, cells_6x2, cells_2x2, cells_2x3, cells_2x4, cells_12x1, cells_4x4, cells_4x3, cells_4x2} = props.appState;
		const {id} = props.details

		if (props.details.available) {
			if (willOccupyCells === 2) {
				if (activeInitialBaseplate === '10x3') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_10x3[0].available && cells_10x3[1].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_10x3[2].available && cells_10x3[3].available
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_10x3[4].available && cells_10x3[5].available
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_10x3[6].available && cells_10x3[7].available
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells_10x3[8].available && cells_10x3[9].available
						}
					}
	
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells_10x3[10].available && cells_10x3[11].available
						}
					}
	
					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14) {
							return cells_10x3[12].available && cells_10x3[13].available
						}
					}
	
					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16) {
							return cells_10x3[14].available && cells_10x3[15].available
						}
					}
	
					else if (hoverCell === 17 || hoverCell === 18) {
						if (id === 17 || id === 18) {
							return cells_10x3[16].available && cells_10x3[17].available
						}
					}

					else if (hoverCell === 19 || hoverCell === 20) {
						if (id === 19 || id === 20) {
							return cells_10x3[18].available && cells_10x3[19].available
						}
					}

					else if (hoverCell === 21 || hoverCell === 22) {
						if (id === 21 || id === 22) {
							return cells_10x3[20].available && cells_10x3[21].available
						}
					}

					else if (hoverCell === 23 || hoverCell === 24) {
						if (id === 23 || id === 24) {
							return cells_10x3[22].available && cells_10x3[23].available
						}
					}

					else if (hoverCell === 25 || hoverCell === 26) {
						if (id === 25 || id === 26) {
							return cells_10x3[24].available && cells_10x3[25].available
						}
					}

					else if (hoverCell === 27 || hoverCell === 28) {
						if (id === 27 || id === 28) {
							return cells_10x3[26].available && cells_10x3[27].available
						}
					}

					else if (hoverCell === 29 || hoverCell === 30) {
						if (id === 29 || id === 30) {
							return cells_10x3[28].available && cells_10x3[29].available
						}
					}
				}

				else if (activeInitialBaseplate === '10x2_KOMPANJA') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available
						}
					}
	
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available
						}
					}
	
					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14) {
							return cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available
						}
					}
	
					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16) {
							return cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available
						}
					}
	
					else if (hoverCell === 17 || hoverCell === 18) {
						if (id === 17 || id === 18) {
							return cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available
						}
					}

					else if (hoverCell === 19 || hoverCell === 20) {
						if (id === 19 || id === 20) {
							return cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available
						}
					}
				}

				else if (activeInitialBaseplate === '8x1') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_8x1[0].available && cells_8x1[1].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_8x1[2].available && cells_8x1[3].available
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_8x1[4].available && cells_8x1[5].available
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_8x1[6].available && cells_8x1[7].available
						}
					}
				}
				
				else if (activeInitialBaseplate === '8x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_8x2[0].available && cells_8x2[1].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_8x2[2].available && cells_8x2[3].available
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_8x2[4].available && cells_8x2[5].available
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_8x2[6].available && cells_8x2[7].available
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells_8x2[8].available && cells_8x2[9].available
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells_8x2[10].available && cells_8x2[11].available
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14) {
							return cells_8x2[12].available && cells_8x2[13].available
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16) {
							return cells_8x2[14].available && cells_8x2[15].available
						}
					}
				}

				else if (activeInitialBaseplate === '6x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_6x2[0].available && cells_6x2[1].available
						}
					}
					
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_6x2[2].available && cells_6x2[3].available
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_6x2[4].available && cells_6x2[5].available
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_6x2[6].available && cells_6x2[7].available
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells_6x2[8].available && cells_6x2[9].available
						}
					}
	
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells_6x2[10].available && cells_6x2[11].available
						}
					}
				}

				else if (activeInitialBaseplate === '2x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_2x2[0].available && cells_2x2[1].available
						}
					}
					
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_2x2[2].available && cells_2x2[3].available
						}
					}
				}

				else if (activeInitialBaseplate === '2x3') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_2x3[0].available && cells_2x3[1].available
						}
					}
					
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_2x3[2].available && cells_2x3[3].available
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_2x3[4].available && cells_2x3[5].available
						}
					}
				}

				else if (activeInitialBaseplate === '2x4') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_2x4[0].available && cells_2x4[1].available
						}
					}
					
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_2x4[2].available && cells_2x4[3].available
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_2x4[4].available && cells_2x4[5].available
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_2x4[6].available && cells_2x4[7].available
						}
					}
				}

				else if (activeInitialBaseplate === '12x1') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_12x1[0].available && cells_12x1[1].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_12x1[2].available && cells_12x1[3].available
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_12x1[4].available && cells_12x1[5].available
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_12x1[6].available && cells_12x1[7].available
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells_12x1[8].available && cells_12x1[9].available
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells_12x1[10].available && cells_12x1[11].available
						}
					}
				}

				else if (activeInitialBaseplate === '4x4') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_4x4[0].available && cells_4x4[1].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_4x4[2].available && cells_4x4[3].available
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_4x4[4].available && cells_4x4[5].available
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_4x4[6].available && cells_4x4[7].available
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells_4x4[8].available && cells_4x4[9].available
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells_4x4[10].available && cells_4x4[11].available
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14) {
							return cells_4x4[12].available && cells_4x4[13].available
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16) {
							return cells_4x4[14].available && cells_4x4[15].available
						}
					}
				}

				else if (activeInitialBaseplate === '4x3') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_4x3[0].available && cells_4x3[1].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_4x3[2].available && cells_4x3[3].available
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_4x3[4].available && cells_4x3[5].available
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_4x3[6].available && cells_4x3[7].available
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells_4x3[8].available && cells_4x3[9].available
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells_4x3[10].available && cells_4x3[11].available
						}
					}
				}

				else if (activeInitialBaseplate === '4x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_4x2[0].available && cells_4x2[1].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_4x2[2].available && cells_4x2[3].available
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_4x2[4].available && cells_4x2[5].available
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_4x2[6].available && cells_4x2[7].available
						}
					}
				}

				// Default baseplate
				else {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells[0].available && cells[1].available
						}
					}
					
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells[2].available && cells[3].available
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells[4].available && cells[5].available
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells[6].available && cells[7].available
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells[8].available && cells[9].available
						}
					}
	
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells[10].available && cells[11].available
						}
					}
	
					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14) {
							return cells[12].available && cells[13].available
						}
					}
	
					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16) {
							return cells[14].available && cells[15].available
						}
					}
	
					else if (hoverCell === 17 || hoverCell === 18) {
						if (id === 17 || id === 18) {
							return cells[16].available && cells[17].available
						}
					}
				}
			}
 
			// Pocket bottle
			else if (willOccupyCells === 2.2) { 
				if (activeInitialBaseplate === '10x3') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 11 || id === 12) {
							return (cells_10x3[0].available && cells_10x3[1].available && cells_10x3[10].available && cells_10x3[11].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 13 || id === 14) {
							return (cells_10x3[2].available && cells_10x3[3].available && cells_10x3[12].available && cells_10x3[13].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 15 || id === 16) {
							return (cells_10x3[4].available && cells_10x3[5].available && cells_10x3[14].available && cells_10x3[15].available )
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 17 || id === 18) {
							return (cells_10x3[6].available && cells_10x3[7].available && cells_10x3[16].available && cells_10x3[17].available )
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10 || id === 19 || id === 20) {
							return (cells_10x3[8].available && cells_10x3[9].available && cells_10x3[18].available && cells_10x3[19].available )
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 21 || id === 22) {
							return (cells_10x3[10].available && cells_10x3[11].available && cells_10x3[20].available && cells_10x3[21].available )
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 23 || id === 24) {
							return (cells_10x3[12].available && cells_10x3[13].available && cells_10x3[22].available && cells_10x3[23].available )
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16 || id === 25 || id === 26) {
							return (cells_10x3[14].available && cells_10x3[15].available && cells_10x3[24].available && cells_10x3[25].available )
						}
					}

					else if (hoverCell === 17 || hoverCell === 18) {
						if (id === 17 || id === 18 || id === 27 || id === 28) {
							return (cells_10x3[16].available && cells_10x3[17].available && cells_10x3[26].available && cells_10x3[27].available )
						}
					}

					else if (hoverCell === 19 || hoverCell === 20) {
						if (id === 19 || id === 20 || id === 29 || id === 30) {
							return (cells_10x3[18].available && cells_10x3[19].available && cells_10x3[28].available && cells_10x3[29].available )
						}
					}

					else if (hoverCell === 21 || hoverCell === 22) {
						if (id === 21 || id === 22) {
							return (cells_10x3[20].available && cells_10x3[21].available)
						}
					}

					else if (hoverCell === 23 || hoverCell === 24) {
						if (id === 23 || id === 24) {
							return (cells_10x3[22].available && cells_10x3[23].available)
						}
					}

					else if (hoverCell === 25 || hoverCell === 26) {
						if (id === 25 || id === 26) {
							return (cells_10x3[24].available && cells_10x3[25].available)
						}
					}

					else if (hoverCell === 27 || hoverCell === 28) {
						if (id === 27 || id === 28) {
							return (cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell === 29 || hoverCell === 30) {
						if (id === 29 || id === 30) {
							return (cells_10x3[28].available && cells_10x3[29].available)
						}
					}
				}

				else if (activeInitialBaseplate === '10x2_KOMPANJA') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 11 || id === 12) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 13 || id === 14) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 15 || id === 16) {
							return (cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available )
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 17 || id === 18) {
							return (cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available )
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10 || id === 19 || id === 20) {
							return (cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available )
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 1 || id === 2) {
							return (cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available )
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 3 || id === 4) {
							return (cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available )
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16 || id === 5 || id === 6) {
							return (cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available )
						}
					}

					else if (hoverCell === 17 || hoverCell === 18) {
						if (id === 17 || id === 18 || id === 7 || id === 8) {
							return (cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available )
						}
					}

					else if (hoverCell === 19 || hoverCell === 20) {
						if (id === 19 || id === 20 || id === 9 || id === 10) {
							return (cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available && cells_10x2_KOMPANJA[8].available && cells_10x3[9].available )
						}
					}
				}

				else if (activeInitialBaseplate === '8x1') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return (cells_8x1[0].available && cells_8x1[1].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return (cells_8x1[2].available && cells_8x1[3].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return (cells_8x1[4].available && cells_8x1[5].available)
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return (cells_8x1[6].available && cells_8x1[7].available)
						}
					}
				}

				else if (activeInitialBaseplate === '8x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 9 || id === 10) {
							return (cells_8x2[0].available && cells_8x2[1].available && cells_8x2[8].available && cells_8x2[9].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 11 || id === 12) {
							return (cells_8x2[2].available && cells_8x2[3].available && cells_8x2[10].available && cells_8x2[11].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 13 || id === 14) {
							return (cells_8x2[4].available && cells_8x2[5].available && cells_8x2[12].available && cells_8x2[13].available )
						}
					}	

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 15 || id === 16) {
							return (cells_8x2[6].available && cells_8x2[7].available && cells_8x2[14].available && cells_8x2[15].available )
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return (cells_8x2[8].available && cells_8x2[9].available)
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return (cells_8x2[10].available && cells_8x2[11].available)
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14) {
							return (cells_8x2[12].available && cells_8x2[13].available)
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16) {
							return (cells_8x2[14].available && cells_8x2[15].available)
						}
					}
				}

				else if (activeInitialBaseplate === '6x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 7 || id === 8) {
							return (cells_6x2[0].available && cells_6x2[1].available && cells_6x2[6].available && cells_6x2[7].available )
						}
					}
	
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 9 || id === 10 ) {
							return (cells_6x2[2].available && cells_6x2[3].available && cells_6x2[8].available && cells_6x2[9].available )
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 11 || id === 12 ) {
							return (cells_6x2[4].available && cells_6x2[5].available && cells_6x2[10].available && cells_6x2[11].available )
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 13 || id === 14 ) {
							return (cells_6x2[6].available && cells_6x2[7].available)
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return (cells_6x2[8].available && cells_6x2[9].available)
						}
					}
	
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return (cells_6x2[10].available && cells_6x2[11].available)
						}
					}
				}

				else if (activeInitialBaseplate === '2x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_2x2[0].available && cells_2x2[1].available && cells_2x2[2].available && cells_2x2[3].available )
						}
					}
	
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 ) {
							return (cells_2x2[2].available && cells_2x2[3].available)
						}
					}
				}

				else if (activeInitialBaseplate === '2x3') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_2x3[0].available && cells_2x3[1].available && cells_2x3[2].available && cells_2x3[3].available )
						}
					}
	
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_2x3[2].available && cells_2x3[3].available && cells_2x3[4].available && cells_2x3[5].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 ) {
							return (cells_2x3[4].available && cells_2x3[5].available)
						}
					}
				}

				else if (activeInitialBaseplate === '2x4') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_2x4[0].available && cells_2x4[1].available && cells_2x4[2].available && cells_2x4[3].available )
						}
					}
	
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_2x4[2].available && cells_2x4[3].available && cells_2x4[4].available && cells_2x4[5].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_2x4[4].available && cells_2x4[5].available && cells_2x4[6].available && cells_2x4[7].available )
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return(cells_2x4[6].available && cells_2x4[7].available)
						}
					}
				}

				else if (activeInitialBaseplate === '12x1') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2) {
							return cells_12x1[0].available && cells_12x1[1].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4) {
							return cells_12x1[2].available && cells_12x1[3].available
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_12x1[4].available && cells_12x1[5].available
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_12x1[6].available && cells_12x1[7].available
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells_12x1[8].available && cells_12x1[9].available
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells_12x1[10].available && cells_12x1[11].available
						}
					}
				}

				else if (activeInitialBaseplate === '4x4') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 5 || id === 6) {
							return cells_4x4[0].available && cells_4x4[1].available && cells_4x4[4].available && cells_4x4[5].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 7 || id === 8) {
							return cells_4x4[2].available && cells_4x4[3].available && cells_4x4[6].available && cells_4x4[7].available
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 9 || id === 10) {
							return cells_4x4[4].available && cells_4x4[5].available && cells_4x4[8].available && cells_4x4[9].available
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 11 || id === 12) {
							return cells_4x4[6].available && cells_4x4[7].available && cells_4x4[10].available && cells_4x4[11].available
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10 || id === 13 || id === 14) {
							return cells_4x4[8].available && cells_4x4[9].available && cells_4x4[12].available && cells_4x4[13].available
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 15 || id === 16) {
							return cells_4x4[10].available && cells_4x4[11].available && cells_4x4[14].available && cells_4x4[15].available
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14) {
							return cells_4x4[12].available && cells_4x4[13].available	
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16) {
							return cells_4x4[14].available && cells_4x4[15].available
						}
					}
				}

				else if (activeInitialBaseplate === '4x3') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 5 || id === 6) {
							return cells_4x3[0].available && cells_4x3[1].available && cells_4x3[4].available && cells_4x3[5].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 7 || id === 8) {
							return cells_4x3[2].available && cells_4x3[3].available && cells_4x3[6].available && cells_4x3[7].available
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 9 || id === 10) {
							return cells_4x3[4].available && cells_4x3[5].available && cells_4x3[8].available && cells_4x3[9].available
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 11 || id === 12) {
							return cells_4x3[6].available && cells_4x3[7].available && cells_4x3[10].available && cells_4x3[11].available
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10) {
							return cells_4x3[8].available && cells_4x3[9].available
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12) {
							return cells_4x3[10].available && cells_4x3[11].available
						}
					}
				}

				else if (activeInitialBaseplate === '4x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 5 || id === 6) {
							return cells_4x2[0].available && cells_4x2[1].available && cells_4x2[4].available && cells_4x2[5].available
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 7 || id === 8) {
							return cells_4x2[2].available && cells_4x2[3].available && cells_4x2[6].available && cells_4x2[7].available
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6) {
							return cells_4x2[4].available && cells_4x2[5].available
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8) {
							return cells_4x2[6].available && cells_4x2[7].available 
						}
					}
				}

				else {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 7 || id === 8) {
							return (cells[0].available && cells[1].available && cells[6].available && cells[7].available )
						}
					}
	
					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 9 || id === 10 ) {
							return (cells[2].available && cells[3].available && cells[8].available && cells[9].available )
						}
					}
	
					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 11 || id === 12 ) {
							return (cells[4].available && cells[5].available && cells[10].available && cells[11].available )
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 13 || id === 14 ) {
							return (cells[6].available && cells[7].available && cells[12].available && cells[13].available )
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10 || id === 15 || id === 16 ) {
							return (cells[8].available && cells[9].available && cells[14].available && cells[15].available )
						}
					}
	
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 17 || id === 18 ) {
							return (cells[10].available && cells[11].available && cells[16].available && cells[17].available )
						}
					}
	
					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 ) {
							return (cells[12].available && cells[13].available )
						}
					}
	
					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16 ) {
							return (cells[14].available && cells[15].available )
						}
					}
	
					else if (hoverCell === 17 || hoverCell === 18) {
						if (id === 17 || id === 18 ) {
							return (cells[16].available && cells[17].available )
						}
					}
				}
			}
	
			// Pocket Medium
			else if (willOccupyCells === 4) {
				if (activeInitialBaseplate === '10x3') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_10x3[0].available && cells_10x3[1].available && cells_10x3[2].available && cells_10x3[3].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_10x3[4].available && cells_10x3[5].available && cells_10x3[6].available && cells_10x3[7].available )
						}
					}

					else if (hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10) {
						if (id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells_10x3[6].available && cells_10x3[7].available && cells_10x3[8].available && cells_10x3[9].available )
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available )
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available )
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available )
						}
					}

					else if (hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20) {
						if (id === 17 || id === 18 || id === 19 || id === 20) {
							return (cells_10x3[16].available && cells_10x3[17].available && cells_10x3[18].available && cells_10x3[19].available )
						}
					}

					else if (hoverCell === 21 || hoverCell === 22) {
						if (id === 21 || id === 22 || id === 23 || id === 24) {
							return (cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available )
						}
					}

					else if (hoverCell === 23 || hoverCell === 24) {
						if (id === 23 || id === 24 || id === 25 || id === 26) {
							return (cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available )
						}
					}

					else if (hoverCell === 25 || hoverCell === 26) {
						if (id === 25 || id === 26 || id === 27 || id === 28) {
							return (cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available )
						}
					}

					else if (hoverCell === 27 || hoverCell === 28 || hoverCell === 29 || hoverCell === 30) {
						if (id === 27 || id === 28 || id === 29 || id === 30) {
							return (cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available && cells_10x3[29].available )
						}
					}

				}

				else if (activeInitialBaseplate === '10x2_KOMPANJA') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available )
						}
					}

					else if (hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10) {
						if (id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available )
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available )
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available )
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available )
						}
					}

					else if (hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20) {
						if (id === 17 || id === 18 || id === 19 || id === 20) {
							return (cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available )
						}
					}
				}

				else if (activeInitialBaseplate === '8x1') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_8x1[0].available && cells_8x1[1].available && cells_8x1[2].available && cells_8x1[3].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_8x1[4].available && cells_8x1[5].available && cells_8x1[6].available && cells_8x1[7].available )
						}
					}
				}

				else if (activeInitialBaseplate === '8x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_8x2[0].available && cells_8x2[1].available && cells_8x2[2].available && cells_8x2[3].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_8x2[4].available && cells_8x2[5].available && cells_8x2[6].available && cells_8x2[7].available )
						}
					}

					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available )
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available )
						}
					}

					else if (hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16) {
						if (id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available )
						}
					}
				}

				else if (activeInitialBaseplate === '6x2') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells[0].available && cells[1].available && cells[2].available && cells[3].available )
						}
					}
	
					else if (hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells[2].available && cells[3].available && cells[4].available && cells[5].available )
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells[6].available && cells[7].available && cells[8].available && cells[9].available )
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12 ) {
							return (cells[8].available && cells[9].available && cells[10].available && cells[11].available )
						}
					}
				}

				else if (activeInitialBaseplate === '12x1') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_12x1[0].available && cells_12x1[1].available && cells_12x1[2].available && cells_12x1[3].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_12x1[4].available && cells_12x1[5].available && cells_12x1[6].available && cells_12x1[7].available )
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available )
						}
					}

					else if (hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_12x1[8].available && cells_12x1[9].available && cells_12x1[10].available && cells_12x1[11].available )
						}
					}
				}

				else if (activeInitialBaseplate === '4x4') {
					if (hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_4x4[0].available && cells_4x4[1].available && cells_4x4[2].available && cells_4x4[3].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_4x4[4].available && cells_4x4[5].available && cells_4x4[6].available && cells_4x4[7].available )
						}
					}

					else if (hoverCell === 9|| hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_4x4[8].available && cells_4x4[9].available && cells_4x4[10].available && cells_4x4[11].available )
						}
					}

					else if (hoverCell === 13|| hoverCell === 14 || hoverCell === 15 || hoverCell === 16) {
						if (id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_4x4[12].available && cells_4x4[13].available && cells_4x4[14].available && cells_4x4[15].available )
						}
					}
				}

				else if (activeInitialBaseplate === '4x3') {
					if (hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_4x3[0].available && cells_4x3[1].available && cells_4x3[2].available && cells_4x3[3].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_4x3[4].available && cells_4x3[5].available && cells_4x3[6].available && cells_4x3[7].available )
						}
					}

					else if (hoverCell === 9|| hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_4x3[8].available && cells_4x3[9].available && cells_4x3[10].available && cells_4x3[11].available )
						}
					}
				}

				else if (activeInitialBaseplate === '4x2') {
					if (hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_4x2[0].available && cells_4x2[1].available && cells_4x2[2].available && cells_4x2[3].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_4x2[4].available && cells_4x2[5].available && cells_4x2[6].available && cells_4x2[7].available )
						}
					}
				}

				else {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells[0].available && cells[1].available && cells[2].available && cells[3].available )
						}
					}
	
					else if (hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells[2].available && cells[3].available && cells[4].available && cells[5].available )
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells[6].available && cells[7].available && cells[8].available && cells[9].available )
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12 ) {
							return (cells[8].available && cells[9].available && cells[10].available && cells[11].available )
						}
					}
	
					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells[12].available && cells[13].available && cells[14].available && cells[15].available )
						}
					}
	
					else if (hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18) {
						if (id === 15 || id === 16 || id === 17 || id === 18 ) {
							return (cells[14].available && cells[15].available && cells[16].available && cells[17].available )
						}
					}
				}
			}

			else if (willOccupyCells === 5) {
				if (activeInitialBaseplate === '10x3') {
					if (hoverCell === 1) {
						if (id >= 1 && id <= 5) {
							return (cells_10x3[0].available && cells_10x3[1].available && cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available)
						}
					}

					else if (hoverCell === 2) {
						if (id >= 2 && id <= 6) {
							return (cells_10x3[1].available && cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available)
						}
					}

					else if (hoverCell === 3) {
						if (id >= 3 && id <= 7) {
							return (cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available && cells_10x3[6].available)
						}
					}

					else if (hoverCell === 4) {
						if (id >= 4 && id <= 8) {
							return (cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available && cells_10x3[6].available && cells_10x3[7].available)
						}
					}

					else if (hoverCell === 5) {
						if (id >= 5 && id <= 9) {
							return (cells_10x3[4].available && cells_10x3[5].available && cells_10x3[6].available && cells_10x3[7].available && cells_10x3[8].available)
						}
					}

					else if (hoverCell >= 6 && hoverCell <= 10) {
						if (id >= 6 && id <= 10) {
							return (cells_10x3[5].available && cells_10x3[6].available && cells_10x3[7].available && cells_10x3[8].available && cells_10x3[9].available)
						}
					}

					else if (hoverCell === 11) {
						if (id >= 11 && id <= 15) {
							return (cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available)
						}
					}

					else if (hoverCell === 12) {
						if (id >= 12 && id <= 16) {
							return (cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available)
						}
					}

					else if (hoverCell === 13) {
						if (id >= 13 && id <= 17) {
							return (cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available)
						}
					}

					else if (hoverCell === 14) {
						if (id >= 14 && id <= 18) {
							return (cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available)
						}
					}

					else if (hoverCell === 15) {
						if (id >= 15 && id <= 19) {
							return (cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[18].available)
						}
					}

					else if (hoverCell >= 16 && hoverCell <= 20) {
						if (id >= 16 && id <= 20) {
							return (cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[18].available && cells_10x3[19].available)
						}
					}

					else if (hoverCell === 21) {
						if (id >= 21 && id <= 25) {
							return (cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available)
						}
					}

					else if (hoverCell === 22) {
						if (id >= 22 && id <= 26) {
							return (cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available)
						}
					}

					else if (hoverCell === 23) {
						if (id >= 23 && id <= 27) {
							return (cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available)
						}
					}

					else if (hoverCell === 24) {
						if (id >= 24 && id <= 28) {
							return (cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell === 25) {
						if (id >= 25 && id <= 29) {
							return (cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available)
						}
					}

					else if (hoverCell >= 26 && hoverCell <= 30) {
						if (id >= 26 && id <= 30) {
							return (cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available && cells_10x3[29].available)
						}
					}
				
				}

				else if (activeInitialBaseplate === '10x2_KOMPANJA') {
					if (hoverCell === 1) {
						if (id >= 1 && id <= 5) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available)
						}
					}
					
					else if (hoverCell === 2) {
						if (id >= 2 && id <= 6) {
							return (cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available)
						}
					}
					
					else if (hoverCell === 3) {
						if (id >= 3 && id <= 7) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available)
						}
					}
					
					else if (hoverCell === 4) {
						if (id >= 4 && id <= 8) {
							return (cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available)
						}
					}
					
					else if (hoverCell === 5) {
						if (id >= 5 && id <= 9) {
							return (cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available)
						}
					}
					
					else if (hoverCell >= 6 && hoverCell <= 10) {
						if (id >= 6 && id <= 10) {
							return (cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available)
						}
					}
					
					else if (hoverCell === 11) {
						if (id >= 11 && id <= 15) {
							return (cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available)
						}
					}
					
					else if (hoverCell === 12) {
						if (id >= 12 && id <= 16) {
							return (cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available)
						}
					}
					
					else if (hoverCell === 13) {
						if (id >= 13 && id <= 17) {
							return (cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available)
						}
					}
					
					else if (hoverCell === 14) {
						if (id >= 14 && id <= 18) {
							return (cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available)
						}
					}
					
					else if (hoverCell === 15) {
						if (id >= 15 && id <= 19) {
							return (cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available)
						}
					}
					
					else if (hoverCell >= 16 && hoverCell <= 20) {
						if (id >= 16 && id <= 20) {
							return (cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available)
						}
					}
				}

				else if (activeInitialBaseplate === '8x1') {
					if (hoverCell === 1) {
						if (id >= 1 && id <= 5) {
							return (cells_8x1[0].available && cells_8x1[1].available && cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available)
						}
					}
					
					else if (hoverCell === 2) {
						if (id >= 2 && id <= 6) {
							return (cells_8x1[1].available && cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available)
						}
					}
					
					else if (hoverCell === 3) {
						if (id >= 3 && id <= 7) {
							return (cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available && cells_8x1[6].available)
						}
					}
					
					else if (hoverCell >= 4 && hoverCell <= 8) {
						if (id >= 4 && id <= 8) {
							return (cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available && cells_8x1[6].available && cells_8x1[7].available)
						}
					}
				}

				else if (activeInitialBaseplate === '8x2') {
					if (hoverCell === 1) {
						if (id >= 1 && id <= 5) {
							return (cells_8x2[0].available && cells_8x2[1].available && cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available)
						}
					}
					
					else if (hoverCell === 2) {
						if (id >= 2 && id <= 6) {
							return (cells_8x2[1].available && cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available)
						}
					}
					
					else if (hoverCell === 3) {
						if (id >= 3 && id <= 7) {
							return (cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available && cells_8x2[6].available)
						}
					}
					
					else if (hoverCell >= 4 && hoverCell <= 8) {
						if (id >= 4 && id <= 8) {
							return (cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available && cells_8x2[6].available && cells_8x2[7].available)
						}
					}

					else if (hoverCell === 9) {
						if (id >= 9 && id <= 13) {
							return (cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available)
						}
					}
					
					else if (hoverCell === 10) {
						if (id >= 10 && id <= 14) {
							return (cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available)
						}
					}
					
					else if (hoverCell === 11) {
						if (id >= 11 && id <= 15) {
							return (cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available)
						}
					}
					
					else if (hoverCell >= 12 && hoverCell <= 16) {
						if (id >= 12 && id <= 16) {
							return (cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available)
						}
					}
				}

				else if (activeInitialBaseplate === '6x2') {
					if (hoverCell === 1) {
						if (id >= 1 && id <= 5) {
							return (cells_6x2[0].available && cells_6x2[1].available && cells_6x2[2].available && cells_6x2[3].available && cells_6x2[4].available)
						}
					}
					
					else if (hoverCell >= 2 && hoverCell <= 6) {
						if (id >= 2 && id <= 6) {
							return (cells_6x2[1].available && cells_6x2[2].available && cells_6x2[3].available && cells_6x2[4].available && cells_6x2[5].available)
						}
					}
					
					else if (hoverCell === 7) {
						if (id >= 7 && id <= 11) {
							return (cells_6x2[6].available && cells_6x2[7].available && cells_6x2[8].available && cells_6x2[9].available && cells_6x2[10].available)
						}
					}
					
					else if (hoverCell >= 8 && hoverCell <= 12) {
						if (id >= 8 && id <= 12) {
							return (cells_6x2[7].available && cells_6x2[8].available && cells_6x2[9].available && cells_6x2[10].available && cells_6x2[11].available)
						}
					}
				}

				else if (activeInitialBaseplate === '12x1') {
					if (hoverCell === 1) {
						if (id >= 1 && id <= 5) {
							return (cells_12x1[0].available && cells_12x1[1].available && cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available)
						}
					}
					
					else if (hoverCell === 2) {
						if (id >= 2 && id <= 6) {
							return (cells_12x1[1].available && cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available)
						}
					}
					
					else if (hoverCell === 3) {
						if (id >= 3 && id <= 7) {
							return (cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available && cells_12x1[6].available)
						}
					}
					
					else if (hoverCell === 4) {
						if (id >= 4 && id <= 8) {
							return (cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available && cells_12x1[6].available && cells_12x1[7].available)
						}
					}
					
					else if (hoverCell === 5) {
						if (id >= 5 && id <= 9) {
							return (cells_12x1[4].available && cells_12x1[5].available && cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available)
						}
					}
					
					else if (hoverCell === 6) {
						if (id >= 6 && id <= 10) {
							return (cells_12x1[5].available && cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available)
						}
					}
					
					else if (hoverCell === 7) {
						if (id >= 7 && id <= 11) {
							return (cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available && cells_12x1[10].available)
						}
					}
					
					else if (hoverCell >= 8 && hoverCell <= 12) {
						if (id >= 8 && id <= 12) {
							return (cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available && cells_12x1[10].available && cells_12x1[11].available)
						}
					}
				}

				else {
					if (hoverCell === 1) {
						if (id >= 1 && id <= 5) {
							return (cells[0].available && cells[1].available && cells[2].available && cells[3].available && cells[4].available)
						}
					}
					
					else if (hoverCell >= 2 && hoverCell <= 6) {
						if (id >= 2 && id <= 6) {
							return (cells[1].available && cells[2].available && cells[3].available && cells[4].available && cells[5].available)
						}
					}
					
					else if (hoverCell === 7) {
						if (id >= 7 && id <= 11) {
							return (cells[6].available && cells[7].available && cells[8].available && cells[9].available && cells[10].available)
						}
					}
					
					else if (hoverCell >= 8 && hoverCell <= 12) {
						if (id >= 8 && id <= 12) {
							return (cells[7].available && cells[8].available && cells[9].available && cells[10].available && cells[11].available)
						}
					}

					else if (hoverCell === 13) {
						if (id >= 13 && id <= 17) {
							return (cells[12].available && cells[13].available && cells[14].available && cells[15].available && cells[16].available)
						}
					}
					
					else if (hoverCell >= 14 && hoverCell <= 18) {
						if (id >= 14 && id <= 18) {
							return (cells[13].available && cells[14].available && cells[15].available && cells[16].available && cells[17].available)
						}
					}
				}
			}

			else if (willOccupyCells === 6) {
				if (activeInitialBaseplate === '10x3') {
					if (hoverCell >= 1 && hoverCell <= 2) {
						if (id >= 1 && id <= 6) {
							let availabilityStatus = true;
							for (let i = 0; i <= 5; i++) {
								availabilityStatus = cells_10x3[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 3 && hoverCell <= 4) {
						if (id >= 3 && id <= 8) {
							let availabilityStatus = true;
							for (let i = 2; i <= 7; i++) {
								availabilityStatus = cells_10x3[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 5 && hoverCell <= 10) {
						if (id >= 5 && id <= 10) {
							let availabilityStatus = true;
							for (let i = 4; i <= 9; i++) {
								availabilityStatus = cells_10x3[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 11 && hoverCell <= 12) {
						if (id >= 11 && id <= 16) {
							let availabilityStatus = true;
							for (let i = 10; i <= 15; i++) {
								availabilityStatus = cells_10x3[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 13 && hoverCell <= 14) {
						if (id >= 13 && id <= 18) {
							let availabilityStatus = true;
							for (let i = 12; i <= 17; i++) {
								availabilityStatus = cells_10x3[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 15 && hoverCell <= 20) {
						if (id >= 15 && id <= 20) {
							let availabilityStatus = true;
							for (let i = 14; i <= 19; i++) {
								availabilityStatus = cells_10x3[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 21 && hoverCell <= 22) {
						if (id >= 21 && id <= 26) {
							let availabilityStatus = true;
							for (let i = 20; i <= 25; i++) {
								availabilityStatus = cells_10x3[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 23 && hoverCell <= 24) {
						if (id >= 23 && id <= 28) {
							let availabilityStatus = true;
							for (let i = 22; i <= 27; i++) {
								availabilityStatus = cells_10x3[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 25 && hoverCell <= 30) {
						if (id >= 25 && id <= 30) {
							let availabilityStatus = true;
							for (let i = 24; i <= 29; i++) {
								availabilityStatus = cells_10x3[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}
				}

				else if (activeInitialBaseplate === '10x2_KOMPANJA') {
					if (hoverCell >= 1 && hoverCell <= 2) {
						if (id >= 1 && id <= 6) {
							let availabilityStatus = true;
							for (let i = 0; i <= 5; i++) {
								availabilityStatus = cells_10x2_KOMPANJA[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 3 && hoverCell <= 4) {
						if (id >= 3 && id <= 8) {
							let availabilityStatus = true;
							for (let i = 2; i <= 7; i++) {
								availabilityStatus = cells_10x2_KOMPANJA[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 5 && hoverCell <= 10) {
						if (id >= 5 && id <= 10) {
							let availabilityStatus = true;
							for (let i = 4; i <= 9; i++) {
								availabilityStatus = cells_10x2_KOMPANJA[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 11 && hoverCell <= 12) {
						if (id >= 11 && id <= 16) {
							let availabilityStatus = true;
							for (let i = 10; i <= 15; i++) {
								availabilityStatus = cells_10x2_KOMPANJA[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 13 && hoverCell <= 14) {
						if (id >= 13 && id <= 18) {
							let availabilityStatus = true;
							for (let i = 12; i <= 17; i++) {
								availabilityStatus = cells_10x2_KOMPANJA[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 15 && hoverCell <= 20) {
						if (id >= 15 && id <= 20) {
							let availabilityStatus = true;
							for (let i = 14; i <= 19; i++) {
								availabilityStatus = cells_10x2_KOMPANJA[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}
				}

				else if (activeInitialBaseplate === '8x1') {
					if (hoverCell >= 1 && hoverCell <= 2) {
						if (id >= 1 && id <= 6) {
							let availabilityStatus = true;
							for (let i = 0; i <= 5; i++) {
								availabilityStatus = cells_8x1[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 3 && hoverCell <= 8) {
						if (id >= 3 && id <= 8) {
							let availabilityStatus = true;
							for (let i = 2; i <= 7; i++) {
								availabilityStatus = cells_8x1[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}
				}

				else if (activeInitialBaseplate === '8x2') {
					if (hoverCell >= 1 && hoverCell <= 2) {
						if (id >= 1 && id <= 6) {
							let availabilityStatus = true;
							for (let i = 0; i <= 5; i++) {
								availabilityStatus = cells_8x2[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 3 && hoverCell <= 8) {
						if (id >= 3 && id <= 8) {
							let availabilityStatus = true;
							for (let i = 2; i <= 7; i++) {
								availabilityStatus = cells_8x2[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 9 && hoverCell <= 10) {
						if (id >= 9 && id <= 14) {
							let availabilityStatus = true;
							for (let i = 8; i <= 13; i++) {
								availabilityStatus = cells_8x2[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 11 && hoverCell <= 16) {
						if (id >= 11 && id <= 16) {
							let availabilityStatus = true;
							for (let i = 10; i <= 15; i++) {
								availabilityStatus = cells_8x2[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}
				}

				else if (activeInitialBaseplate === '6x2') {
					if (hoverCell >= 1 && hoverCell <= 6) {
						if (id >= 1 && id <= 6) {
							let availabilityStatus = true;
							for (let i = 0; i <= 5; i++) {
								availabilityStatus = cells_6x2[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 7 && hoverCell <= 12) {
						if (id >= 7 && id <= 12) {
							let availabilityStatus = true;
							for (let i = 6; i <= 11; i++) {
								availabilityStatus = cells_6x2[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}
				}

				else if (activeInitialBaseplate === '12x1') {
					if (hoverCell >= 1 && hoverCell <= 2) {
						if (id >= 1 && id <= 2) {
							let availabilityStatus = true;
							for (let i = 0; i <= 5; i++) {
								availabilityStatus = cells_12x1[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 3 && hoverCell <= 4) {
						if (id >= 3 && id <= 8) {
							let availabilityStatus = true;
							for (let i = 2; i <= 7; i++) {
								availabilityStatus = cells_12x1[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 5 && hoverCell <= 6) {
						if (id >= 5 && id <= 10) {
							let availabilityStatus = true;
							for (let i = 4; i <= 9; i++) {
								availabilityStatus = cells_12x1[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 7 && hoverCell <= 12) {
						if (id >= 7 && id <= 12) {
							let availabilityStatus = true;
							for (let i = 6; i <= 11; i++) {
								availabilityStatus = cells_12x1[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}
				}

				else {
					if (hoverCell >= 1 && hoverCell <= 6) {
						if (id >= 1 && id <= 6) {
							let availabilityStatus = true;
							for (let i = 0; i <= 5; i++) {
								availabilityStatus = cells[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 7 && hoverCell <= 12) {
						if (id >= 7 && id <= 12) {
							let availabilityStatus = true;
							for (let i = 6; i <= 11; i++) {
								availabilityStatus = cells[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}

					else if (hoverCell >= 13 && hoverCell <= 18) {
						if (id >= 13 && id <= 18) {
							let availabilityStatus = true;
							for (let i = 12; i <= 17; i++) {
								availabilityStatus = cells[i].available;
								// If we find false value, break the loop. We can't drop
								if (!availabilityStatus) {
									break
								}
							}
							return(availabilityStatus);
						}
					}
				}
			}

			// Pocket Big
			else if (willOccupyCells === 8) {
				if (activeInitialBaseplate === '10x3') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_10x3[0].available && cells_10x3[1].available && cells_10x3[2].available && cells_10x3[3].available && cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells_10x3[4].available && cells_10x3[5].available && cells_10x3[6].available && cells_10x3[7].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available)
						}
					}

					else if (hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10) {
						if (id === 7 || id === 8 || id === 9 || id === 10 || id === 17 || id === 18 || id === 19 || id === 20) {
							return (cells_10x3[6].available && cells_10x3[7].available && cells_10x3[8].available && cells_10x3[9].available && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[18].available && cells_10x3[19].available)
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 13 || id === 14 || id === 21 || id === 22 || id === 23 || id === 24) {
							return (cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available)
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 15 || id === 16 || id === 23 || id === 24 || id === 25 || id === 26) {
							return (cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available)
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16 || id === 17 || id === 18 || id === 25 || id === 26 || id === 27 || id === 28) {
							return (cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20) {
						if (id === 17 || id === 18 || id === 19 || id === 20 || id === 27 || id === 28 || id === 29 || id === 30) {
							return (cells_10x3[16].available && cells_10x3[17].available && cells_10x3[18].available && cells_10x3[19].available && cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available && cells_10x3[29].available)
						}
					}

					else if (hoverCell === 21 || hoverCell === 22) {
						if (id === 21 || id === 22 || id === 23 || id === 24) {
							return (cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available)
						}
					}

					else if (hoverCell === 23 || hoverCell === 24) {
						if (id === 23 || id === 24 || id === 25 || id === 26) {
							return (cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available)
						}
					}

					else if (hoverCell === 25 || hoverCell === 26) {
						if (id === 25 || id === 26 || id === 27 || id === 28) {
							return (cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell === 27 || hoverCell === 28 || hoverCell === 29 || hoverCell === 30) {
						if (id === 27 || id === 28 || id === 29 || id === 30) {
							return (cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available && cells_10x3[29].available)
						}
					}
				}

				else if (activeInitialBaseplate === '10x2_KOMPANJA') {
					// Row 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available)
						}
					}

					else if (hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10) {
						if (id === 7 || id === 8 || id === 9 || id === 10 || id === 17 || id === 18 || id === 19 || id === 20) {
							return (cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available)
						}
					}

					// Row 2
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 13 || id === 14 || id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available)
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 15 || id === 16 || id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available)
						}
					}

					else if (hoverCell === 15 || hoverCell === 16) {
						if (id === 15 || id === 16 || id === 17 || id === 18 || id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available)
						}
					}

					else if (hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20) {
						if (id === 17 || id === 18 || id === 19 || id === 20 || id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available)
						}
					}
				}

				else if (activeInitialBaseplate === '8x1') {
					// Row 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_8x1[0].available && cells_8x1[1].available && cells_8x1[2].available && cells_8x1[3].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_8x1[4].available && cells_8x1[5].available && cells_8x1[6].available && cells_8x1[7].available)
						}
					}
				}

				else if (activeInitialBaseplate === '8x2') {
					// Row 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_8x2[0].available && cells_8x2[1].available && cells_8x2[2].available && cells_8x2[3].available && cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_8x2[4].available && cells_8x2[5].available && cells_8x2[6].available && cells_8x2[7].available && cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available)
						}
					}

					// Row 2
					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available)
						}
					}

					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available)
						}
					}

					else if (hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16) {
						if (id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available)
						}
					}
				}

				else if (activeInitialBaseplate === '6x2') {

					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells_6x2[0].available && cells_6x2[1].available && cells_6x2[2].available && cells_6x2[3].available && cells_6x2[6].available && cells_6x2[7].available && cells_6x2[8].available && cells_6x2[9].available)
						}
					}
	
					else if (hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_6x2[2].available && cells_6x2[3].available && cells_6x2[4].available && cells_6x2[5].available && cells_6x2[8].available && cells_6x2[9].available && cells_6x2[10].available && cells_6x2[11].available)
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells_6x2[6].available && cells_6x2[7].available && cells_6x2[8].available && cells_6x2[9].available)
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12 ) {
							return (cells_6x2[8].available && cells_6x2[9].available && cells_6x2[10].available && cells_6x2[11].available)
						}
					}
				}

				else if (activeInitialBaseplate === '12x1') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4) {
							return (cells_12x1[0].available && cells_12x1[1].available && cells_12x1[2].available && cells_12x1[3].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_12x1[4].available && cells_12x1[5].available && cells_12x1[6].available && cells_12x1[7].available )
						}
					}

					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available )
						}
					}

					else if (hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_12x1[8].available && cells_12x1[9].available && cells_12x1[10].available && cells_12x1[11].available )
						}
					}
				}
				
				else if (activeInitialBaseplate === '4x4') {
					if (hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_4x4[0].available && cells_4x4[1].available && cells_4x4[2].available && cells_4x4[3].available && cells_4x4[4].available && cells_4x4[5].available && cells_4x4[6].available && cells_4x4[7].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_4x4[4].available && cells_4x4[5].available && cells_4x4[6].available && cells_4x4[7].available && cells_4x4[8].available && cells_4x4[9].available && cells_4x4[10].available && cells_4x4[11].available)
						}
					}

					else if (hoverCell === 9|| hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_4x4[8].available && cells_4x4[9].available && cells_4x4[10].available && cells_4x4[11].available && cells_4x4[12].available && cells_4x4[13].available && cells_4x4[14].available && cells_4x4[15].available)
						}
					}

					else if (hoverCell === 13|| hoverCell === 14 || hoverCell === 15 || hoverCell === 16) {
						if (id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_4x4[12].available && cells_4x4[13].available && cells_4x4[14].available && cells_4x4[15].available )
						}
					}
				}

				else if (activeInitialBaseplate === '4x3') {
					if (hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_4x3[0].available && cells_4x3[1].available && cells_4x3[2].available && cells_4x3[3].available && cells_4x3[4].available && cells_4x3[5].available && cells_4x3[6].available && cells_4x3[7].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_4x3[4].available && cells_4x3[5].available && cells_4x3[6].available && cells_4x3[7].available && cells_4x3[8].available && cells_4x3[9].available && cells_4x3[10].available && cells_4x3[11].available)
						}
					}

					else if (hoverCell === 9|| hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12 ) {
							return (cells_4x3[8].available && cells_4x3[9].available && cells_4x3[10].available && cells_4x3[11].available)
						}
					}
				}

				else if (activeInitialBaseplate === '4x2') {
					if (hoverCell === 1 || hoverCell === 2 || hoverCell === 3 || hoverCell === 4) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_4x2[0].available && cells_4x2[1].available && cells_4x2[2].available && cells_4x2[3].available && cells_4x2[4].available && cells_4x2[5].available && cells_4x2[6].available && cells_4x2[7].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_4x2[4].available && cells_4x2[5].available && cells_4x2[6].available && cells_4x2[7].available)
						}
					}
				}


				else {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells[0].available && cells[1].available && cells[2].available && cells[3].available && cells[6].available && cells[7].available && cells[8].available && cells[9].available)
						}
					}
	
					else if (hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells[2].available && cells[3].available && cells[4].available && cells[5].available && cells[8].available && cells[9].available && cells[10].available && cells[11].available)
						}
					}
	
					else if (hoverCell === 7 || hoverCell === 8) {
						if (id === 7 || id === 8 || id === 9 || id === 10 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells[6].available && cells[7].available && cells[8].available && cells[9].available && cells[12].available && cells[13].available && cells[14].available && cells[15].available)
						}
					}
	
					else if (hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 9 || id === 10 || id === 11 || id === 12 || id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells[8].available && cells[9].available && cells[10].available && cells[11].available && cells[14].available && cells[15].available && cells[16].available && cells[17].available)
						}
					}
	
					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells[12].available && cells[13].available && cells[14].available && cells[15].available)
						}
					}
	
					else if (hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18) {
						if (id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells[14].available && cells[15].available && cells[16].available && cells[17].available)
						}
					}
				}
			}
			
			// Pocket X Large
			else if (willOccupyCells === 12) {
				if (activeInitialBaseplate === '10x3') {
					// ROW 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_10x3[0].available && cells_10x3[1].available && cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available && cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8 || id === 13 || id === 14 || id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available  && cells_10x3[6].available && cells_10x3[7].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available  && cells_10x3[16].available && cells_10x3[17].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10 || id === 15 || id === 16 || id === 17 || id === 18 || id === 19 || id === 20) {
							return (cells_10x3[4].available && cells_10x3[5].available && cells_10x3[6].available && cells_10x3[7].available && cells_10x3[8].available && cells_10x3[9].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[18].available && cells_10x3[19].available)
						}
					}


					// ROW 1
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16 || id === 21 || id === 22 || id === 23 || id === 24 || id === 25 || id === 26) {
							return (cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[23].available && cells_10x3[24].available)
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 15 || id === 16 || id === 17 || id === 18 || id === 23 || id === 24 || id === 25 || id === 26 || id === 27 || id === 28) {
							return (cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20) {
						if (id === 15 || id === 16 || id === 17 || id === 18 || id === 19 || id === 20 || id === 25 || id === 26 || id === 27 || id === 28 || id === 29 || id === 30) {
							return (cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available  && cells_10x3[18].available && cells_10x3[19].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available && cells_10x3[29].available)
						}
					}


					// ROW 3
					else if (hoverCell === 21 || hoverCell === 22 ) {
						if (id === 21 || id === 22 || id === 23 || id === 24 || hoverCell === 25 || hoverCell === 26) {
							return (cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available)
						}
					}

					else if (hoverCell === 23 || hoverCell === 24) {
						if (id === 23 || id === 24 || id === 25 || id === 26 || id === 27 || id === 28) {
							return (cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell === 25 || hoverCell === 26 || hoverCell === 27 || hoverCell === 28 || hoverCell === 29 || hoverCell === 30) {
						if (id === 25 || id === 26 || id === 27 || id === 28 || id === 29 || id === 30) {
							return (cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available  && cells_10x3[28].available && cells_10x3[29].available)
						}
					}
				}

				else if (activeInitialBaseplate === '10x2_KOMPANJA') {
					// Row 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8 || id === 13 || id === 14 || id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10 || id === 15 || id === 16 || id === 17 || id === 18 || id === 19 || id === 20) {
							return (cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available)
						}
					}

					// Row 2
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available)
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8 || id === 13 || id === 14 || id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available)
						}
					}

					else if (hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10 || id === 15 || id === 16 || id === 17 || id === 18 || id === 19 || id === 20) {
							return (cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available)
						}
					}
				}

				else if (activeInitialBaseplate === '8x1') {
					// Row 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 ) {
							return (cells_8x1[0].available && cells_8x1[1].available && cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 3 || id === 4 ||id === 5 || id === 6 || id === 7 || id === 8) {
							return ( cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available && cells_8x1[6].available && cells_8x1[7].available)
						}
					}
				}
				
				else if (activeInitialBaseplate === '8x2') {
					// Row 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 9 || id === 10 || id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_8x2[0].available && cells_8x2[1].available && cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available && cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8 || id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available && cells_8x2[6].available && cells_8x2[7].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available)
						}
					}


					// Row 2
					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10 || id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available)
						}
					}

					else if ( hoverCell === 11 || hoverCell === 12 || hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16) {
						if (id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available)
						}
					}
				}

				else if (activeInitialBaseplate === '6x2') {

					if (hoverCell >= 1 && hoverCell <= 6) {
						if (id >= 1 && id <= 12) {
							return (cells_6x2[0].available && cells_6x2[1].available && cells_6x2[2].available && cells_6x2[3].available && cells_6x2[4].available && cells_6x2[5].available && cells_6x2[6].available && cells_6x2[7].available && cells_6x2[8].available && cells_6x2[9].available && cells_6x2[10].available && cells_6x2[11].available)
						}
					}
	
					else if (hoverCell >= 7 && hoverCell <= 12) {
						if (id >= 7 && id <= 12) {
							return (cells_6x2[6].available && cells_6x2[7].available && cells_6x2[8].available && cells_6x2[9].available && cells_6x2[10].available && cells_6x2[11].available) 
						}
					}
				}

				else if (activeInitialBaseplate === '12x1') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_12x1[0].available && cells_12x1[1].available && cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available && cells_12x1[6].available && cells_12x1[7].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells_12x1[4].available && cells_12x1[5].available && cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available )
						}
					}

					else if (hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 7 || id === 8 || id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available && cells_12x1[10].available && cells_12x1[11].available )
						}
					}
				}

				// 6x3
				else {
					if (hoverCell >= 1 && hoverCell <= 6) {
						if (id >= 1 && id <= 12) {
							return (cells[0].available && cells[1].available && cells[2].available && cells[3].available && cells[4].available && cells[5].available && cells[6].available && cells[7].available && cells[8].available && cells[9].available && cells[10].available && cells[11].available)
						}
					}
	
					else if (hoverCell >= 7 && hoverCell <= 12) {
						if (id >= 7 && id <= 18) {
							return (cells[6].available && cells[7].available && cells[8].available && cells[9].available && cells[10].available && cells[11].available && cells[12].available && cells[13].available && cells[14].available && cells[15].available && cells[16].available && cells[17].available) 
						}
					}
	
					else if (hoverCell >= 13 && hoverCell <= 18) {
						if (id >= 13 && id <= 18) {
							return (cells[12].available && cells[13].available && cells[14].available && cells[15].available && cells[16].available && cells[17].available)
						}
					}
				}
			}

      else if (willOccupyCells === 18) {
				if (activeInitialBaseplate === '10x3') {
					// ROW 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16 || id === 21 || id === 22 || id === 23 || id === 24 || id === 25 || id === 26) {
							return (cells_10x3[0].available && cells_10x3[1].available && cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available && cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8 || id === 13 || id === 14 || id === 15 || id === 16 || id === 17 || id === 18 || id === 23 || id === 24 || id === 25 || id === 26 || id === 27 || id === 28) {
							return (cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available  && cells_10x3[6].available && cells_10x3[7].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available  && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available  && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10 || id === 15 || id === 16 || id === 17 || id === 18 || id === 19 || id === 20 || id === 25 || id === 26 || id === 27 || id === 28 || id === 29 || id === 30) {
							return (cells_10x3[4].available && cells_10x3[5].available && cells_10x3[6].available && cells_10x3[7].available && cells_10x3[8].available && cells_10x3[9].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[18].available && cells_10x3[19].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available && cells_10x3[29].available)
						}
					}


					// ROW 1
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16 || id === 21 || id === 22 || id === 23 || id === 24 || id === 25 || id === 26) {
							return (cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[23].available && cells_10x3[24].available)
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 13 || id === 14 || id === 15 || id === 16 || id === 17 || id === 18 || id === 23 || id === 24 || id === 25 || id === 26 || id === 27 || id === 28) {
							return (cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20) {
						if (id === 15 || id === 16 || id === 17 || id === 18 || id === 19 || id === 20 || id === 25 || id === 26 || id === 27 || id === 28 || id === 29 || id === 30) {
							return (cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available  && cells_10x3[18].available && cells_10x3[19].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available && cells_10x3[29].available)
						}
					}


					// ROW 3
					else if (hoverCell === 21 || hoverCell === 22 ) {
						if (id === 21 || id === 22 || id === 23 || id === 24 || hoverCell === 25 || hoverCell === 26) {
							return (cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available)
						}
					}

					else if (hoverCell === 23 || hoverCell === 24) {
						if (id === 23 || id === 24 || id === 25 || id === 26 || id === 27 || id === 28) {
							return (cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell === 25 || hoverCell === 26 || hoverCell === 27 || hoverCell === 28 || hoverCell === 29 || hoverCell === 30) {
						if (id === 25 || id === 26 || id === 27 || id === 28 || id === 29 || id === 30) {
							return (cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available  && cells_10x3[28].available && cells_10x3[29].available)
						}
					}
				}

				else if (activeInitialBaseplate === '10x2_KOMPANJA') {
					// Row 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8 || id === 13 || id === 14 || id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available)
						}
					}

					else if (hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10 || id === 15 || id === 16 || id === 17 || id === 18 || id === 19 || id === 20) {
							return (cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available)
						}
					}

					// Row 2
					else if (hoverCell === 11 || hoverCell === 12) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available)
						}
					}

					else if (hoverCell === 13 || hoverCell === 14) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8 || id === 13 || id === 14 || id === 15 || id === 16 || id === 17 || id === 18) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available)
						}
					}

					else if (hoverCell === 15 || hoverCell === 16 || hoverCell === 17 || hoverCell === 18 || hoverCell === 19 || hoverCell === 20) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10 || id === 15 || id === 16 || id === 17 || id === 18 || id === 19 || id === 20) {
							return (cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available)
						}
					}
				}

				else if (activeInitialBaseplate === '8x1') {
					// Row 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 ) {
							return (cells_8x1[0].available && cells_8x1[1].available && cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 3 || id === 4 ||id === 5 || id === 6 || id === 7 || id === 8) {
							return ( cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available && cells_8x1[6].available && cells_8x1[7].available)
						}
					}
				}
				
				else if (activeInitialBaseplate === '8x2') {
					// Row 1
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6 || id === 9 || id === 10 || id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_8x2[0].available && cells_8x2[1].available && cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available && cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available)
						}
					}

					else if (hoverCell === 3 || hoverCell === 4 || hoverCell === 5 || hoverCell === 6 || hoverCell === 7 || hoverCell === 8) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8 || id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available && cells_8x2[6].available && cells_8x2[7].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available)
						}
					}


					// Row 2
					else if (hoverCell === 9 || hoverCell === 10) {
						if (id === 9 || id === 10 || id === 11 || id === 12 || id === 13 || id === 14) {
							return (cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available)
						}
					}

					else if ( hoverCell === 11 || hoverCell === 12 || hoverCell === 13 || hoverCell === 14 || hoverCell === 15 || hoverCell === 16) {
						if (id === 11 || id === 12 || id === 13 || id === 14 || id === 15 || id === 16) {
							return (cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available)
						}
					}
				}

				else if (activeInitialBaseplate === '6x2') {

					if (hoverCell >= 1 && hoverCell <= 6) {
						if (id >= 1 && id <= 12) {
							return (cells_6x2[0].available && cells_6x2[1].available && cells_6x2[2].available && cells_6x2[3].available && cells_6x2[4].available && cells_6x2[5].available && cells_6x2[6].available && cells_6x2[7].available && cells_6x2[8].available && cells_6x2[9].available && cells_6x2[10].available && cells_6x2[11].available)
						}
					}
	
					else if (hoverCell >= 7 && hoverCell <= 12) {
						if (id >= 7 && id <= 12) {
							return (cells_6x2[6].available && cells_6x2[7].available && cells_6x2[8].available && cells_6x2[9].available && cells_6x2[10].available && cells_6x2[11].available) 
						}
					}
				}

				else if (activeInitialBaseplate === '12x1') {
					if (hoverCell === 1 || hoverCell === 2) {
						if (id === 1 || id === 2 || id === 3 || id === 4 || id === 5 || id === 6) {
							return (cells_12x1[0].available && cells_12x1[1].available && cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available )
						}
					}

					else if (hoverCell === 3 || hoverCell === 4) {
						if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8) {
							return (cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available && cells_12x1[6].available && cells_12x1[7].available )
						}
					}

					else if (hoverCell === 5 || hoverCell === 6) {
						if (id === 5 || id === 6 || id === 7 || id === 8 || id === 9 || id === 10) {
							return (cells_12x1[4].available && cells_12x1[5].available && cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available )
						}
					}

					else if (hoverCell === 7 || hoverCell === 8 || hoverCell === 9 || hoverCell === 10 || hoverCell === 11 || hoverCell === 12) {
						if (id === 7 || id === 8 || id === 9 || id === 10 || id === 11 || id === 12) {
							return (cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available && cells_12x1[10].available && cells_12x1[11].available )
						}
					}
				}

				// 6x3
				else {
					if (hoverCell >= 1 && hoverCell <= 6) {
						if (id >= 1 && id <= 18) {
							return (cells[0].available && cells[1].available && cells[2].available && cells[3].available && cells[4].available && cells[5].available && cells[6].available && cells[7].available && cells[8].available && cells[9].available && cells[10].available && cells[11].available && cells[12].available && cells[13].available && cells[14].available && cells[15].available && cells[16].available && cells[17].available)
						}
					}
	
					else if (hoverCell >= 7 && hoverCell <= 12) {
						if (id >= 7 && id <= 18) {
							return (cells[6].available && cells[7].available && cells[8].available && cells[9].available && cells[10].available && cells[11].available && cells[12].available && cells[13].available && cells[14].available && cells[15].available && cells[16].available && cells[17].available) 
						}
					}
	
					else if (hoverCell >= 13 && hoverCell <= 18) {
						if (id >= 13 && id <= 18) {
							return (cells[12].available && cells[13].available && cells[14].available && cells[15].available && cells[16].available && cells[17].available)
						}
					}
				}
			}

			else if (willOccupyCells === 16) {
				if (activeInitialBaseplate === '10x3') {
					if (hoverCell >= 1 && hoverCell <= 2) {
						if (id >= 1 && id <= 8 || id >= 11 && id <= 18) {
							return (cells_10x3[0].available && cells_10x3[1].available && cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available  && cells_10x3[6].available && cells_10x3[7].available && cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available  && cells_10x3[16].available && cells_10x3[17].available)
						}
					}

					else if (hoverCell >= 3 && hoverCell <= 10) {
						if (id >= 3 && id <= 10 || id >= 13 && id <= 20) {
							return (cells_10x3[2].available && cells_10x3[3].available && cells_10x3[4].available && cells_10x3[5].available  && cells_10x3[6].available && cells_10x3[7].available && cells_10x3[8].available && cells_10x3[9].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[18].available && cells_10x3[19].available)
						}
					}

					else if (hoverCell >= 11 && hoverCell <= 12) {
						if (id >= 11 && id <= 18 || id >= 21 && id <= 28) {
							return (cells_10x3[10].available && cells_10x3[11].available && cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available  && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available  && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell >= 13 && hoverCell <= 20) {
						if (id >= 13 && id <= 20 || id >= 23 && id <= 30) {
							return (cells_10x3[12].available && cells_10x3[13].available && cells_10x3[14].available && cells_10x3[15].available  && cells_10x3[16].available && cells_10x3[17].available && cells_10x3[18].available && cells_10x3[19].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available && cells_10x3[29].available)
						}
					}

					else if (hoverCell >= 21 && hoverCell <= 22) {
						if (id >= 21 && id <= 28 ) {
							return (cells_10x3[20].available && cells_10x3[21].available && cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available  && cells_10x3[26].available && cells_10x3[27].available)
						}
					}

					else if (hoverCell >= 23 && hoverCell <= 30) {
						if (id >= 23 && id <= 30) {
							return (cells_10x3[22].available && cells_10x3[23].available && cells_10x3[24].available && cells_10x3[25].available && cells_10x3[26].available && cells_10x3[27].available && cells_10x3[28].available && cells_10x3[29].available)
						}
					}
				}

				else if (activeInitialBaseplate === '10x2_KOMPANJA') {
					if (hoverCell >= 1 && hoverCell <= 2) {
						if (id >= 1 && id <= 8 || id >= 11 && id <= 18) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available  && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available  && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available)
						}
					}
					
					else if (hoverCell >= 3 && hoverCell <= 10) {
						if (id >= 3 && id <= 10 || id >= 13 && id <= 20) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available  && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available)
						}
					}
					
					else if (hoverCell >= 11 && hoverCell <= 12) {
						if (id >= 1 && id <= 8 || id >= 11 && id <= 18) {
							return (cells_10x2_KOMPANJA[0].available && cells_10x2_KOMPANJA[1].available && cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available  && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[10].available && cells_10x2_KOMPANJA[11].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available  && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available)
						}
					}
					
					else if (hoverCell >= 13 && hoverCell <= 20) {
						if (id >= 3 && id <= 10 || id >= 13 && id <= 20) {
							return (cells_10x2_KOMPANJA[2].available && cells_10x2_KOMPANJA[3].available && cells_10x2_KOMPANJA[4].available && cells_10x2_KOMPANJA[5].available  && cells_10x2_KOMPANJA[6].available && cells_10x2_KOMPANJA[7].available && cells_10x2_KOMPANJA[8].available && cells_10x2_KOMPANJA[9].available && cells_10x2_KOMPANJA[12].available && cells_10x2_KOMPANJA[13].available && cells_10x2_KOMPANJA[14].available && cells_10x2_KOMPANJA[15].available && cells_10x2_KOMPANJA[16].available && cells_10x2_KOMPANJA[17].available && cells_10x2_KOMPANJA[18].available && cells_10x2_KOMPANJA[19].available)
						}
					}					
				}

				else if (activeInitialBaseplate === '8x1') {
					if (hoverCell >= 1 && hoverCell <= 8) {
						if (id >= 1 && id <= 8 ) {
							return (cells_8x1[0].available && cells_8x1[1].available && cells_8x1[2].available && cells_8x1[3].available && cells_8x1[4].available && cells_8x1[5].available  && cells_8x1[6].available && cells_8x1[7].available)
						}
					}
				}
				
				else if (activeInitialBaseplate === '8x2') {
					if (hoverCell >= 1 && hoverCell <= 8) {
						if (id >= 1 && id <= 16 ) {
							return (cells_8x2[0].available && cells_8x2[1].available && cells_8x2[2].available && cells_8x2[3].available && cells_8x2[4].available && cells_8x2[5].available  && cells_8x2[6].available && cells_8x2[7].available && cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available)
						}
					}
				
					else if (hoverCell >= 9 && hoverCell <= 16) {
						if (id >= 9 && id <= 16 ) {
							return (cells_8x2[8].available && cells_8x2[9].available && cells_8x2[10].available && cells_8x2[11].available && cells_8x2[12].available && cells_8x2[13].available && cells_8x2[14].available && cells_8x2[15].available)
						}
					}
				}

				else if (activeInitialBaseplate === '12x1') {
					if (hoverCell >= 1 && hoverCell <= 2) {
						if (id >= 1 && id <= 8) {
							return (cells_12x1[0].available && cells_12x1[1].available && cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available  && cells_12x1[6].available && cells_12x1[7].available)
						}
					}

					else if (hoverCell >= 3 && hoverCell <= 4) {
						if (id >= 3 && id <= 4) {
							return (cells_12x1[2].available && cells_12x1[3].available && cells_12x1[4].available && cells_12x1[5].available  && cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available)
						}
					}

					else if (hoverCell >= 5 && hoverCell <= 12) {
						if (id >= 5 && id <= 12) {
							return (cells_12x1[4].available && cells_12x1[5].available  && cells_12x1[6].available && cells_12x1[7].available && cells_12x1[8].available && cells_12x1[9].available && cells_12x1[10].available && cells_12x1[11].available)
						}
					}
				}
			}
		}
		return true
	}
};

const collect = (connect, monitor) => {
	return {
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver().valueOf(),
		canDrop: monitor.canDrop(),
		getItem: monitor.getItem(),
	}
}

class DropProduct extends Component {
	// This will highlight the unavailable stuff
	// ${isDragging && !canDrop ? 'unavailable' : ''}

	render() {
		const { isOver, canDrop, details } = this.props;
		const {isDragging, activeInitialBaseplate} = this.props.appState;

		const { connectDropTarget } = this.props;
		return connectDropTarget(
			<div className={`cell has-plug
				${isOver ? 'is-over':''} 
				${isDragging && !canDrop ? 'unavailable' : ''}
				${canDrop ? 'available': ''} 
				${details.drawPreview ? 'draw-preview' : ''}
				${details.id % 2 === 0 ? 'even' : 'odd'}
				${
					activeInitialBaseplate === '10x3' ? (
						details.id  === 1 ? 'border-radius-top-left' 
						: details.id === 10 ? 'border-radius-top-right'
						: details.id === 21 ? 'border-radius-bottom-left' 
						: details.id === 30 ? 'border-radius-bottom-right' 
						: null
					) : activeInitialBaseplate === '10x2_KOMPANJA' ? (
						details.id  === 1 ? 'border-radius-top-left' 
						: details.id === 10 ? 'border-radius-top-right'
						: details.id === 11 ? 'border-radius-bottom-left' 
						: details.id === 20 ? 'border-radius-bottom-right' 
						: null
					) : activeInitialBaseplate === '4x4' ? (
						details.id  === 1 ? 'border-radius-top-left' 
						: details.id === 4 ? 'border-radius-top-right'
						: details.id === 13 ? 'border-radius-bottom-left' 
						: details.id === 16 ? 'border-radius-bottom-right' 
						: null
					) : activeInitialBaseplate === '4x3' ? (
						details.id  === 1 ? 'border-radius-top-left' 
						: details.id === 4 ? 'border-radius-top-right'
						: details.id === 9 ? 'border-radius-bottom-left' 
						: details.id === 12 ? 'border-radius-bottom-right' 
						: null
					) : 
					activeInitialBaseplate === '4x2' ? (
						details.id  === 1 ? 'border-radius-top-left' 
						: details.id === 4 ? 'border-radius-top-right'
						: details.id === 5 ? 'border-radius-bottom-left' 
						: details.id === 8 ? 'border-radius-bottom-right' 
						: null
					) : 
					activeInitialBaseplate === '12x1' ? (
						details.id === 1 ? 'border-radius-bottom-left' 
						: details.id === 12 ? 'border-radius-bottom-right' 
						: null
					) : 

					activeInitialBaseplate === '8x1' ? (
						details.id === 1 ? 'border-radius-bottom-left' 
						: details.id === 8 ? 'border-radius-bottom-right' 
						: null
					) : 

					activeInitialBaseplate === '8x2' ? (
						details.id === 9 ? 'border-radius-bottom-left' 
						: details.id === 16 ? 'border-radius-bottom-right' 
						: null
					) : 

					activeInitialBaseplate === '10x3' ? (
						details.id === 21 ? 'border-radius-bottom-left' 
						: details.id === 30 ? 'border-radius-bottom-right' 
						: null
					) : 

					// Default baseplate
					details.id  === 1 ? 'border-radius-top-left' 
					: details.id === 6 ? 'border-radius-top-right'
					: details.id === 13 ? 'border-radius-bottom-left' 
					: details.id === 18 ? 'border-radius-bottom-right' 
					: null 
				}
				`}>
					
				<div className="plug">
					{/* <span style={{backgroundColor: 'black', padding: 10}}>{this.props.id + 1}</span> */}
				</div>
			</div>
		)
	}
}
export default DropTarget(Types.ITEM, itemTarget, collect)(DropProduct)